import ordflokkar from './ordflokkar_mork.json'

const generateTooltipFromTag = (tag) => {
  const out = {}
  // Fyrsti stafur er alltaf ordflokkur
  out['Orðflokkur'] = ordflokkar[tag];

  if (tag.length < 2) {
    return stringifyObject(out);
  }

  switch (out['Orðflokkur']) {
    case 'Nafnorð':
      out['Kyn'] = kyn[tag[1]];
      out['Tala'] = tala[tag[2]];
      out['Fall'] = fall[tag[3]];
      if (tag.length > 4 && tag[4]==='g') {
        out['Greinir'] = greinir[tag[4]];
      }
      if (tag.length > 5) {
        out['Sérnafn'] = sernafn[tag[5]]
      }
      break;

    case 'Lýsingarorð':
      out['Kyn'] = kyn[tag[1]];
      out['Tala'] = tala[tag[2]];
      out['Fall'] = fall[tag[3]];
      out['Beyging'] = loBeyging[tag[4]];
      out['Stig'] = loStig[tag[5]];
      break;

    case 'Fornafn':
      out['Flokkur'] = fnFlokkur[tag[1]];
      out['Kyn/Persóna'] = kyn[tag[2]];
      out['Tala'] = tala[tag[3]];
      out['Fall'] = fall[tag[4]];
      break;

    case 'Greinir':
      out['Kyn'] = kyn[tag[1]];
      out['Tala'] = tala[tag[2]];
      out['Fall'] = fall[tag[3]];
      break;

    case 'Töluorð':
      out['Flokkur'] = toFlokkur[tag[1]];
      out['Kyn'] = kyn[tag[2]];
      out['Tala'] = tala[tag[3]];
      out['Fall'] = fall[tag[4]];
      break;

    case 'Sagnorð':
      out['Háttur'] = hattur[tag[1]];
      out['Mynd'] = mynd[tag[2]];
      if (out['Háttur'] === 'Lýsingarháttur þátíðar') {
        out['Kyn'] = kyn[tag[3]];
        out['Fall'] = fall[tag[5]];
      } else {
        out['Persóna'] = persona[tag[3]];
        out['Tíð'] = tid[tag[5]];
      }
      out['Tala'] = tala[tag[4]];
      break;

    case 'Atviksorð':
    case 'Forsetning':
      out['Fallstjórn'] = aoFallstjorn[tag[1]];
      out['Stig'] = loStig[tag[2]];
      break;
    case 'Samtenging':
      out['Flokkur'] = stFlokkur[tag[1]]
      break;
    case 'Nafnháttarmerki':
    case 'Skammstöfun':
    case 'Upphrópun':
      break;

    default:
      console.log("Shouldn't happen: ", out['Orðflokkur'], tag);
  }


  if (out['Orðflokkur']==='Sagnorð') {

  }

  if (out['Orðflokkur']==='Sagnorð') {

  }

  return stringifyObject(out);

}

const stringifyObject = (obj) => {
  return Object.keys(obj)
    .filter(key => (
      obj[key]
    ))
    .map((key)=>{
      return key + ": " + obj[key]
    })
    .join('\n')
}


const kyn = {
  'x': 'Ókyngreint',
  'k': 'Karlkyn',
  'v': 'Kvenkyn',
  'h': 'Hvorugkyn',
  '1': '1. persóna',
  '2': '2. persóna'
}

const tala = {
  'e': 'Eintala',
  'f': 'Fleirtala'
}

const fall = {
  'n': 'Nefnifall',
  'o': 'Þolfall',
  'þ': 'Þágufall',
  'e': 'Eignarfall'
}

const fnFlokkur = {
  'a': 'Ábendingarfornafn',
  'b': 'Óákveðið ábendingarfornafn',
  'e': 'Eignarfornafn',
  'o': 'Óákveðið fornafn',
  'p': 'Persónufornafn',
  's': 'Spurnarfornafn',
  't': 'Tilvísunarfornafn'
}

const greinir = {
  'g': 'Með viðskeyttum greini'
}

const sernafn = {
  'm': 'Mannsnafn',
  'ö': 'Örnefni',
  's': 'Önnur sérnöfn'
}

const loBeyging = {
  's': 'Sterk beyging',
  'v': 'Veik beyging',
  'o': 'Óbeygt'
}

const loStig = {
  'f': 'Frumstig',
  'm': 'Miðstig',
  'e': 'Efstastig'
}

const toFlokkur = {
  'f': 'Frumtala',
  'a': 'Ártöl og fleiri óbeygjanlegar tölur',
  'p': 'Prósentutölur',
  'o': 'Fjöldatölur framan við hundrað og þúsund'
}

const hattur = {
  'n': 'Nafnháttur',
  'b': 'Boðháttur',
  'f': 'Framsöguháttur',
  'v': 'Viðtengingarháttur',
  's': 'Sagnbót',
  'l': 'Lýsingarháttur nútíðar',
  'þ': 'Lýsingarháttur þátíðar'
}

const mynd = {
  'g': 'Germynd',
  'm': 'Miðmynd'
}

const persona = {
  '1': '1. persóna',
  '2': '2. persóna',
  '3': '3. persóna',
}

const tid = {
  'n': 'Nútíð',
  'þ': 'Þátíð'
}

const aoFallstjorn = {
  'a': 'Stýrir ekki falli',
  'o': 'Stýrir þolfalli',
  'þ': 'Stýrir þágufalli',
  'e': 'Stýrir eignarfalli',
  'f': 'Fallstjórn ótilgreind'
}

const stFlokkur = {
  'n': 'Nafnháttarmerki',
  't': 'Tilvísunartenging'
}

export default generateTooltipFromTag;



// WEBPACK FOOTER //
// ./src/Util/decodeTag.js